
import { Component, Vue } from 'vue-property-decorator';
import QvInput from '@/components/FormComponents/QvInput.vue';
import QvSelect from '@/components/FormComponents/QvSelect.vue';
import { ValidationObserver } from 'vee-validate';
import { FarmStore, CommonStore, ConfigurationStore } from '@/store/modules';
import LocationInputMap from '@/components/Forms/Components/LocationInputMap.vue';
import helpers from '@/utils/helpers';
import { HarvestLoadConfiguration } from '@/store/models/configuration';

@Component({
  components: {
    ValidationObserver,
    QvInput,
    QvSelect,
    LocationInputMap
  }
})
export default class FarmForm extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  harvestLoadConfiguration: HarvestLoadConfiguration = {} as HarvestLoadConfiguration;

  get currentFarm() {
    return CommonStore.SelectedFarmBlock;
  }

  async onSubmit() {
    if (
      this.harvestLoadConfiguration.id &&
      this.harvestLoadConfiguration.id != 0
    ) {
      await ConfigurationStore.updateHarvestLoadConfiguration(
        this.harvestLoadConfiguration
      );
      this.$q.notify({
        message: 'Harvest load configuration updated successfully',
        type: 'positive'
      });
    }
  }

  onReset() {
    requestAnimationFrame(() => {
      this.$refs.observer.reset();
      this.$router.push({ name: 'Settings' });
    });
  }

  get farms() {
    return FarmStore.Farms;
  }

  async loadFarm() {
    await ConfigurationStore.getHarvestLoadConfigurationByFarmId(
      this.currentFarm.farmId
    );
    this.harvestLoadConfiguration = ConfigurationStore.HarvestLoadConfiguration;
    this.harvestLoadConfiguration = {
      id: this.harvestLoadConfiguration.id,
      harvestCapacity: this.harvestLoadConfiguration.harvestCapacity,
      harvestCapacityThreshold: this.harvestLoadConfiguration
        .harvestCapacityThreshold,
      weight: this.harvestLoadConfiguration.weight,
      fieldBinSize: this.harvestLoadConfiguration.fieldBinSize
    };
  }

  async created() {
    await helpers.fetchingDefaultFarm();
    this.loadFarm();
  }
}
